import Vue from 'vue';
import axios from 'axios';
import VueI18n from 'vue-i18n';
import VueAxios from 'vue-axios';
import VueMaskDirective from 'vue-mask-directive';
import App from './App';
import store from './store/';
import router from './router';
import api from './api/claroApi';
import packagesService from './services/packagesService';
import routes from './router/claro';
import MainLoading from './components/MainLoading';
import ClaroSection from './components/ClaroSection';
import LoadingScreen from './components/LoadingScreen';
import UseCountry from './middlewares/UseCountry';
import EnterToPin from './middlewares/EnterToPin';
import PayRedirect from './middlewares/PayRedirect';
import AfterPinValidated from './middlewares/AfterPinValidated';
import NotEnterDemoViews from './middlewares/NotEnterDemoViews';
import Navigating from './middlewares/Navigating';
import EventHub from './plugins/EventHub';
import messages from './i18n';

Vue.config.productionTip = false;

const axiosInstance = axios.create({
  timeout: 5000
});

const routeInstance = router(routes);

routeInstance.beforeEach((to, from, next) => {
  Navigating(store, to, from, next);
  UseCountry(store, to, from, next);
  NotEnterDemoViews(store, to, from, next);
  EnterToPin(store, to, from, next);
  AfterPinValidated(store, to, from, next);
  PayRedirect(store, to, from, next);
});

Vue.use(VueI18n);
Vue.use(EventHub);
Vue.use(VueMaskDirective);
Vue.use(VueAxios, axiosInstance);

Vue.component('MainLoading', MainLoading);
Vue.component('ClaroSection', ClaroSection);
Vue.component('LoadingScreen', LoadingScreen);

global.api = api();
global.packagesService = packagesService();
global.router = routeInstance;

const i18n = new VueI18n({
  locale: 'gt',
  fallbackLocale: 'gt',
  messages
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router: routeInstance,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js